
<template>
  <van-popup
    v-model="show"
    @opened="opened"
    @close='close'
    @closed='closed'
    :close-on-popstate="true"
    :close-on-click-overlay="false"
  >
    <div class="dialog-container">
      <div class="coupon-header"
       :style="{
          backgroundImage: 'url(' + dialogHeaderBackgroundImage + ')',
        }"
        >
        <div class="text1">{{$t('FoodC_Task_Congratulations_pDXl')}}</div>
        <div class="text2">{{rewardDesc}}</div>
      </div>
      <div class="coupon-body">
        <div
          v-for="(item, index) in getCouponData"
          :key="index"
          class="award-coupon"
        >
          <AwardCoupon
            :couponData="item"
            :isHasReward="true"
            :isCompleteMission="true"
          />
        </div>
      </div>
      <div class="coupon-footer">
          <div class="go-order" @click="goRedirectUrl">{{$t('FoodC_C_Go_tdhw')}}</div>
      </div>
      <div class="close-icon" @click="closeDialog">
        <img src="../../../../assets/images/oldCustomer/close_icon.png" alt="" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'
import AwardCoupon from '../subAward/awardCoupon.vue'
import dialogHeaderDidi from '@/assets/images/oldCustomer/dialog_coupon_didi.png'
import dialogHeader99 from '@/assets/images/oldCustomer/dialog_coupon_99.png'

Vue.use(Popup)

export default {
  name: 'CouponDialog',
  components: {
    AwardCoupon
  },
  props: {
    couponList: {
      default: () => []
    },
    couponDialogShow: {
      default: false
    },
    rewardDesc: {
      default: ''
    },
    positioningX: {
      default: 0
    },
    positioningY: {
      default: 0
    },
    isUseAnimation: {
      default: true
    }
  },
  computed: {
    dialogHeaderBackgroundImage () {
      if (this.getCountry === 'BR') return dialogHeader99
      return dialogHeaderDidi
    },
    // 获取对应的国家
    getCountry () {
      return this.$store.state.country
    },
    getCouponData () {
      return this.couponList.map((item) => {
        return {
          ...item,
          customerLogo: item.customLogo
        }
      })
    }
  },

  data () {
    return {
      show: false,
      dialogWidth: '',
      dialogHeight: ''
    }
  },
  watch: {
    show (newV) {
      this.$emit('update:couponDialogShow', newV)
    },
    couponDialogShow (newV) {
      this.show = newV
    }
  },
  methods: {
    closeDialog () {
      this.show = false
    },
    goRedirectUrl () {
      this.show = false
      this.$emit('TaskCouponRedenvelopeCk')
    },

    opened () {
      const el = document.querySelector('.van-popup--center') || {}
      const height = el.getBoundingClientRect && el.getBoundingClientRect().height
      const width = el.getBoundingClientRect && el.getBoundingClientRect().width
      el.style.height = height + 'px'
      el.style.width = width + 'px'
      this.dialogHeight = height
      this.dialogWidth = width
    },
    close () {
      if (!this.isUseAnimation) return
      const el = document.querySelector('.van-popup--center').style
      el.transition = 'all 0.3s'
      el.width = '0px'
      el.height = '0px'
      el.left = this.positioningX + 'px'
      el.top = this.positioningY + 'px'

      const vanPopupCenterEl = document.querySelector('.dialog-container')
      vanPopupCenterEl.classList.add('dialog-container_active')
      // vanPopupCenterEl.width = '0px'
      // vanPopupCenterEl.height = '0px'
      // vanPopupCenterEl.transition = 'all 0.3s'
    },
    closed () {
      if(this.isUseAnimation) {
        const el = document.querySelector('.van-popup--center').style
        el.width = `auto`
        el.height = `auto`
        el.left = '50%'
        el.top = '50%'
        const vanPopupCenterEl = document.querySelector('.dialog-container')
        vanPopupCenterEl.classList.remove('dialog-container_active')
      }
      // vanPopupCenterEl.width = `auto`
      // vanPopupCenterEl.height = `auto`

      this.$emit('dialog-close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";

.dialog-container {
  width: 614px;
  ::v-deep .award-container {
    background: none;
    padding-bottom: 0;
    .coupon-container {
      width: 566px;
      min-height: 176px;
      box-shadow: none;
      overflow: hidden;
      border-radius: 8px;
    }
    .coupon-ui-bg-img {
      background-color: rgba(0, 0, 0, 0) !important;
    }
    .coupon-cell {
      width: 566px;
      min-height: 176px;
      .coupon-dl dt {
        padding: 0 !important;
      }
      .coupon-logo {
        img {
          width: 96px !important;
          height: 96px !important;
          margin: 40px 12px 40px 24px !important;
        }
      }
      .title {
        font-size: 28px !important;
        line-height: 30px !important;
        width: 196px !important;
      }
      .time {
        width: 196px !important;
        font-size: 24px !important;
      }
      dl dd {
        min-height: auto;
        .discount {
          font-size: 44px !important;
          font-weight: 600 !important;
        }
      }
    }
  }
}
.dialog-container_active{
  width: 0;
  height: 0;
  transition: all 0.3s
}
.award-coupon {
  margin-bottom: 20px;
}
.award-coupon:last-child {
  margin-bottom: 0px;
}
.coupon-body {
  max-height: 618px;
  overflow-y: auto;
  @include dialog-body-background();
}
.coupon-footer {
  height: 124px;
  border-radius: 0 0 12px 12px;
  @include dialog-body-background();
  display: flex;
  justify-content: center;
  align-items: center;

  .go-order {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 18px 24px;
    font-family: 'Aspira Medium';
    font-size: 28px;
    text-align: center;
    font-weight: 500;
    display: inline-block;
    @include font-color()
  }
  .go-order:active{
          @include new-coupon-bg()
        }
}
.coupon-header {
  overflow: hidden;
  min-height: 216px;
  background-size:100% 216px;
  background-repeat: no-repeat;
  @include dialog-body-background();
  .text1 {
    height: 54px;
    font-family: 'Aspira Demi';
    font-size: 48px;
    color: #FFFFFF;
    line-height: 54px;
    font-weight: 600;
    margin: 40px 0 16px 24px;
  }
  .text2 {
    width: 360px;
    font-family: 'Aspira Light';
    font-size: 28px;
    color: #FFFFFF;
    font-weight: 200;
    line-height: 30px;
    margin-left: 24px;
    margin-bottom: 16px;
    // overflow:hidden;
    // text-overflow:ellipsis;
    // display:-webkit-box;
    // -webkit-box-orient:vertical;
    // -webkit-line-clamp:2;
  }
}
.close-icon {
  padding-top: 48px;
  display: flex;
  justify-content: center;
  img {
     width: 64px;
    height: 64px;
  }
}
.van-popup {
  background: none;
}
</style>
